import AvailablePermissionsPageView from "./AvailablePermissionsPageView";

function AvailablePermissionsPage() {
  return <AvailablePermissionsPageView />;
}

export default AvailablePermissionsPage;
